module.exports = __webpack_public_path__ + "img/icon_dice.29ba6edb.png";